'use strict';

var jquery = require('jquery');

module.exports = {
    getCountries: function getCountries() {
        return jquery.ajax({
            url: '/FormControls/GetCountries',
            method: 'GET'
        });
    },

    getStates: function getStates() {
        return jquery.ajax({
            url: '/FormControls/GetStates',
            method: 'GET'
        });
    },

    getCities: function getCities(stateId) {
        return jquery.ajax({
            url: '/FormControls/GetCities/?stateId=' + stateId,
            method: 'GET'
        });
    },

    getZipCodes: function getZipCodes(stateId, city) {
        return jquery.ajax({
            url: '/FormControls/GetZipCodes/?stateId=' + stateId + '&city=' + city,
            method: 'GET'
        });
    }
}